export default __webpack_public_path__ + "static/media/Deceiver's Bracers of Whispered Deeds.5d898a77.jpg";